import L from 'leaflet';
import 'leaflet-draw';

import * as atlasOps from '../../api/Atlas/atlas-operations';
import * as missionOps from '../../api/Missions/mission-operations';
import * as videoOps from '../../api/Videos/video-operations';

/**
 * Creates the drawing controls for the given feature group.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.drawnItems - The feature group where the geometry layers will be.
 * @param {object} arg.item - The mission or video object.
 * @returns {object} The draw controls for the feature group. Full and edition mode.
 */
const createGeometryDrawControls = ({ drawnItems, item }) => {
  const drawControlFull = new L.Control.Draw({
    edit: {
      featureGroup: drawnItems,
      poly: { allowIntersection: false }
    },
    draw: {
      polygon:
        missionOps.isSuperficial(item) || atlasOps.isFocusedTrain(item)
          ? { allowIntersection: false, showArea: true }
          : false,
      marker: false,
      circle: false,
      polyline: missionOps.isLineal(item) || videoOps.areCoordinatesFromLine(item),
      rectangle: atlasOps.isAI(item) || atlasOps.isDataSet(item),
      circlemarker: videoOps.areCoordinatesFromPoint(item)
    }
  });

  const drawControlEdit = new L.Control.Draw({
    edit: {
      featureGroup: drawnItems,
      poly: { allowIntersection: false }
    },
    draw: false
  });
  return { drawControlFull, drawControlEdit };
};

export default createGeometryDrawControls;
